import { useCallback } from 'react';

import { usePublish } from '@atlaskit/rovo-triggers/main';
import { useSmartCreationChatStoreApi } from '@atlassian/conversation-assistant/controllers/smart-creation-api';

import { useRouterActions } from '@townsquare/router/primitives/actions';
import { useRouter } from '@townsquare/router/useRouter';
import { chatRoute, createChatRouteQuery } from '@townsquare/routes/chat';

export const useViewAllConversations = ({
	closeRovoSidebar,
	handleViewAllConversationsClick,
}: {
	closeRovoSidebar: () => void;
	handleViewAllConversationsClick: () => void;
}): (() => void) => {
	const { pushTo } = useRouterActions();
	const publish = usePublish('ai-mate');
	const [routerState] = useRouter();
	const { setSelectedConversation } = useSmartCreationChatStoreApi();

	return useCallback(() => {
		closeRovoSidebar();
		publish({
			type: 'space-deselected',
			source: 'rovo-sidebar-navigation',
			openChat: false,
		});
		pushTo(chatRoute, {
			query: createChatRouteQuery(routerState.query, {
				rovoChatPathway: 'all-conversations',
			}),
		});
		handleViewAllConversationsClick();
		setSelectedConversation({ conversationId: '' });
	}, [
		closeRovoSidebar,
		pushTo,
		publish,
		handleViewAllConversationsClick,
		setSelectedConversation,
		routerState.query,
	]);
};
